// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Forgot__form > div {\n  width: 100%;\n}\n\n.Forgot__form > div:not(:first-child) {\n  margin-top: 0.75em;\n}\n\n.Forgot__status {\n  padding: 1rem 0;\n}\n\n.Forgot__status--success {\n  color: green;\n}\n\n.Forgot__status--error {\n  color: #f44336;\n}\n", ""]);
// Exports
module.exports = exports;
